<template>
    <div class="mx-5">
        <ValidationObserver ref="obs" v-slot="{ invalid }">
            <v-card flat>
                <v-form name="formEditarDatosProf" @submit.prevent="guardar">
                    <v-row>
                        <v-col :class="($vuetify.breakpoint.mobile) ? 'my-2' : 'my-5'">
                            <div class="d-flex flex justify-start font-weight-bold primary--text text-h6">
                                Datos profesionales
                            </div>
                        </v-col>
                    </v-row>
                    <v-row class="mt-5">
                        <v-col cols="12" md="12">
                            <v-text-field dense v-model="matricula" disabled @keydown="preventArrowKeys"
                                hide-spin-buttons label="Nº matrícula">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="12">
                            <ValidationProvider rules="required|max:10" v-slot="v">
                                <v-text-field v-model="dataSelected.fectit" dense label="Fecha de título:" type="date"
                                    :error-messages="v.errors[0]"></v-text-field>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="12">
                            <ValidationProvider rules="required|max:10" v-slot="v">
                                <v-text-field v-model="dataSelected.fecmat" dense label="Fecha de matriculación:"
                                    type="date" :error-messages="v.errors[0]" @change="cantDias"></v-text-field>
                            </ValidationProvider>
                        </v-col>

                        <v-col cols="12" md="6">
                            <ValidationProvider rules="required|max:10" v-slot="v">
                                <v-text-field dense v-model="dataSelected.tomo"
                                    @input="dataSelected.tomo = dataSelected.tomo.toUpperCase()" hide-spin-buttons
                                    label="Tomo" :error-messages="v.errors[0]">
                                </v-text-field>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="6">
                            <ValidationProvider rules="required|max:10" v-slot="v">
                                <v-text-field name="Folio"
                                    @input="dataSelected.folio = dataSelected.folio.toUpperCase()" dense
                                    v-model="dataSelected.folio" hide-spin-buttons label="Folio"
                                    :error-messages="v.errors[0]">
                                </v-text-field>
                            </ValidationProvider>
                        </v-col>
                        <v-slide-y-transition>
                            <v-col cols="12" md="12" v-if="necesitaArchivos">
                                <v-alert type="warning" dense icon="mdi-alert" color="orange darken-2">
                                    Deberá adjuntar historial de matrícula expedido por el colegio de psicólogos.
                                </v-alert>
                            </v-col>
                        </v-slide-y-transition>
                    </v-row>
                    <v-divider class="mt-8"></v-divider>
                    <v-row>
                        <v-col class='my-2'>
                            <div class="d-flex flex justify-start font-weight-bold primary--text text-h6">
                                Titulo profesional (Frente y dorso):
                            </div>
                        </v-col>
                    </v-row>
                    <v-row class="d-flex flex-row justify-space-between">
                        <v-col cols="6" sm="4" :md="mdCalculado">
                            <InputButtonTitulo @fileSelected="handleFileSelected" op="titFrenteAfiliado"
                                label="TITULO FRENTE" />
                        </v-col>
                        <v-col cols="6" sm="4" :md="mdCalculado">
                            <InputButtonTituloDorso @fileSelected="handleFileSelected" op="titDorsoAfiliado"
                                label="TITULO DORSO" />
                        </v-col>
                        <v-col v-if="necesitaArchivos" cols="6" sm="4" :md="mdCalculado">
                            <InputButtonArchivo @fileSelected="handleFileSelected" op="histMatricula"
                                label="HIST. MATRICULA" />
                        </v-col>
                    </v-row>
                    <v-divider class="my-5"></v-divider>
                    <v-row flat class="d-flex justify-space-between mt-5 mb-2">
                        <v-btn color="primary" outlined elevation="0" @click="volver" class="pa-5">
                            <v-icon class="mr-2">mdi-chevron-left</v-icon>atras
                        </v-btn>
                        <!-- :disabled="invalid || !formValid" -->
                        <v-btn color="primary" outlined elevation="0" type="submit" :disabled="invalid || !formValid"
                            class="m-5 pa-5">
                            <v-icon class="mr-2">mdi-chevron-right</v-icon>siguiente
                        </v-btn>
                    </v-row>
                </v-form>
            </v-card>
        </ValidationObserver>
    </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { mapActions, mapGetters } from 'vuex';
import InputFechaModal from '@/components/inputs/InputFechaModal.vue';
import InputButtonTitulo from '@/components/inputs/InputButtonTitulo.vue';
import InputButtonTituloDorso from '@/components/inputs/InputButtonTituloDorso.vue';
import InputButtonArchivo from '@/components/inputs/InputButtonArchivo.vue';
import InputArchGen from '@/components/inputs/InputArchGen.vue';
import { watch } from 'vue';

export default {
    components: {
        InputFechaModal,
        InputButtonTitulo,
        InputButtonTituloDorso,
        InputButtonArchivo,
        InputArchGen,
        ValidationObserver,
        ValidationProvider,
    },
    data() {
        return {
            nroafi: '',
            dataSelected: {
                tomo: '',
                folio: '',
                fectit: '',
                fecmat: '',
                hayHistorial: false,
            },
            files: [],
            op: 'profesionales',
            tituloValido: false,
            formValid: false,
            hayHistorial: false
        }
    },
    mounted() {
        this.nroafi = this.matricula
    },
    watch: {
        hayHistorial(newValue) {
            console.log(newValue)
            if (!newValue) {
                this.addFilesPre({ op: 'histMatricula', file: '' })
            }
        }
    },
    computed: {
        //preafiliacion
        ...mapGetters('preafiliacion', ['fecnacim', 'matricula', 'itemNivel', 'archProfesionales2', 'titDorsoAfiliado', 'titFrenteAfiliado', 'histMatricula']),

        necesitaArchivos() {
            return (this.hayHistorial)
        },
        mdCalculado() {
            if (!this.necesitaArchivos) return '6'
            else return '4'
        }
    },
    methods: {

        ...mapActions('preafiliacion', ['getOpcionNivel', 'getReducido', 'addFilesPre', 'deleteFiles', 'guardarFechaAfi', 'guardarFechaTitulo', 'guardarFechaMatricula', 'addItemNivel', 'guardarDatosProfesionales']),
        ...mapActions('notificaciones', ['showSnack', 'hideSnack']),

        handleFileSelected() {
            if (!this.necesitaArchivos) {
                ((this.titFrenteAfiliado.length !== 0) && (this.titDorsoAfiliado.length != 0)) ? this.formValid = true : this.formValid = false
            } else ((this.titFrenteAfiliado.length !== 0) && (this.titDorsoAfiliado.length !== 0) && (this.histMatricula.length !== 0) ? this.formValid = true : this.formValid = false)
        },
        calcularEdad(fecha) {
            // retorna la edad 
            const anioNacim = this.fecnacim.split('-')
            const anioCalc = fecha.split('-')
            let edad = anioCalc[0] - anioNacim[0]
            return edad
        },
        volver() {
            this.$emit('atras')
        },
        /* 
        Funciones Adi
        */
        stringToDate(dateString) {
            dateString = dateString.split('-');
            return new Date(dateString[0], dateString[1], dateString[2]);
        },

        countWorkDay(sDay, eDay) {
            var s = this.stringToDate(sDay), e = this.stringToDate(eDay);
            var s_t_w = s.getDay(), e_t_w = e.getDay();
            // Diferencia en días
            var diffDay = (e - s) / (1000 * 60 * 60 * 24) + 1;
            var diffWeekDay = diffDay - (s_t_w == 0 ? 0 : 7 - s_t_w) + e_t_w;
            // El cálculo tiene varias semanas completas
            var weeks = Math.floor(diffWeekDay / 7);
            if (weeks <= 0) {// En la misma semana, es decir, la hora de inicio y finalización no puede ser el domingo y el sábado (el domingo es el primer día de la semana)
                return e_t_w - s_t_w + (s_t_w ? 1 : 0) + (e_t_w == 6 ? -1 : 0);
            } else {
                return weeks * 5 + (e_t_w == 6 ? 5 : e_t_w) + (s_t_w >= 1 && s_t_w <= 5 ? (6 - s_t_w) : 0);
            }
        },

        calcularAnios(fecha) {
            // retorna la cantidad de años que pasaron con respecto a una determinada fecha
            // recibida por parametro 
            const anioNacim = (this.fecnacim).split('-')
            const anioCalc = fecha.split('-')
            let edad = anioCalc[0] - anioNacim[0]
            return edad
        },

        onClearFileInput() {
            console.log('clear formEditarDatosProf')
            this.deleteFiles({ file: '', op: 'profesionales' })
        },

        // evalua si fecha1 es mayor o igual a fecha2
        esMayor(fecha1, fecha2) {
            const [anioUno, mesUno, diaUno] = fecha1.split('-')
            const [anioDos, mesDos, diaDos] = fecha2.split('-')
            if (parseInt(anioUno) > parseInt(anioDos)) {
                return true;
            } else if (parseInt(anioUno) < parseInt(anioDos)) {
                return false;
            }
            if (parseInt(mesUno) > parseInt(mesDos)) {
                return true;
            } else if (parseInt(mesUno) < parseInt(mesDos)) {
                return false;
            }
            if (parseInt(diaUno) >= parseInt(diaDos)) {
                return true;
            } else return false;
        },

        validarFechas(fecafil) {
            const [anioAct, mesActual, diaActual] = fecafil.split('-')
            const [anioTit, mesTit, diaTit] = this.dataSelected.fectit.split('-')

            //calculo si la diferencia entre año actual y el año d titulo es menor a 3 años
            this.tituloValido = ((anioAct - anioTit) < 3)
            if (this.esMayor(fecafil, this.dataSelected.fecmat)) {
                if (!this.esMayor(this.dataSelected.fecmat, this.dataSelected.fectit)) {
                    this.showSnack({
                        message: 'ATENCIÓN: La fecha de Matriculación debe ser mayor a la del Título!',
                        type: '400'
                    })
                    this.dataSelected.fecmat = ''
                    return false
                }
                else {
                    this.showSnack({
                        message: 'Las fechas son correctas',
                        type: '200'
                    })
                    return true
                }
            }
            else {
                this.dataSelected.fecmat = ''
                this.showSnack({
                    message: 'ATENCIÓN: La fecha de Afiliación debe ser mayor a la de Matriculación!',
                    type: '400'
                })
                return false
            }
        },
        calculoAporteReducido(fecafil) {
            if (this.calcularEdad(fecafil) < 35) {
                if (this.calcularEdad(this.dataSelected.fecmat) > 31) {
                    if (this.tituloValido) {
                        console.log('RAR')
                        this.getOpcionNivel()
                        //this.addItemNivel({ id: 7, desc: 'RAR' })
                    }
                }
                console.log('PJ')
                this.getOpcionNivel()
                //this.addItemNivel({ id: 6, desc: 'PJ' },)
            }
            else {
                if (this.tituloValido) {
                    console.log('RAR')
                    this.getOpcionNivel()
                    //this.addItemNivel({ id: 7, desc: 'RAR' })
                }
            }
            // this.nextStep()
        },
        preventArrowKeys(event) {
            if (event.keyCode === 38 || event.keyCode === 40) {
                event.preventDefault();
            }
        },
        cantDias() {
            const today = (new Date()).toJSON().slice(0, 10)
            this.countWorkDay(this.dataSelected.fecmat, today) > 34 ? this.hayHistorial = true : this.hayHistorial = false
        },

        guardar() {
            const today = (new Date()).toJSON().slice(0, 10)
            const fechasOk = this.validarFechas(today)
            this.calculoAporteReducido(today)
            this.$refs.obs.validate().then(result => {
                if (result) {
                    if (fechasOk) {
                        this.guardarDatosProfesionales(this.dataSelected)
                        this.$emit('siguiente')
                    } else {
                        this.showSnack({
                            message: 'Revisar fechas y vuelva a intentar',
                            type: '400'
                        })
                    }
                } else {
                    this.showSnack({
                        message: 'Formulario inválido, no se puede enviar la petición',
                        type: '400'
                    })
                }
            })
        }
    },
}

</script>
